export default __webpack_public_path__ + "static/media/EnQueue.0658333e.gif";